import moment from "moment";

// The API writes timestamps with DateTime.UtcNow into datetime2 columns, which serialize
// WITHOUT a Z suffix. A plain moment() parse reads such a string as local wall time, so for
// any viewer west of UTC the instant lands in the future and fromNow() speaks in the future
// tense ("in 4 hours"). Every render of a server timestamp must parse it as UTC.

/** Relative time for a server-written UTC timestamp: "4 hours ago", "14 days ago". */
export const utcTimeAgo = (value, fallback = "previously") => {
  if (!value) return fallback;
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed.fromNow() : fallback;
};

/** Calendar label for a server-written UTC timestamp, kept on the UTC day. */
export const utcDateLabel = (value, format, fallback = "—") => {
  if (!value) return fallback;
  const parsed = moment.utc(value);
  return parsed.isValid() ? parsed.format(format) : fallback;
};
